var map = {
	"./about": 2,
	"./about.jpg": 2,
	"./ballet": 3,
	"./ballet.svg": 3,
	"./banner": 4,
	"./banner.jpg": 4,
	"./bizx-award": 5,
	"./bizx-award.png": 5,
	"./cd-badge": 6,
	"./cd-badge.png": 6,
	"./equipment": 7,
	"./equipment.svg": 7,
	"./external-link": 8,
	"./external-link.svg": 8,
	"./facebook-cover": 9,
	"./facebook-cover.png": 9,
	"./favicon": 10,
	"./favicon.png": 10,
	"./football": 11,
	"./football.svg": 11,
	"./karate": 12,
	"./karate.svg": 12,
	"./logo": 13,
	"./logo-alt": 14,
	"./logo-alt.png": 14,
	"./logo-white": 15,
	"./logo-white.svg": 15,
	"./logo.svg": 13,
	"./medal": 16,
	"./medal.svg": 16,
	"./netball": 17,
	"./netball.svg": 17,
	"./sports": 18,
	"./sports.jpg": 18,
	"./tactic": 19,
	"./tactic.svg": 19,
	"./tennis": 20,
	"./tennis.svg": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;